// UseHandleContainerClickCandidate.js
import { useNavigate } from 'react-router-dom';

/**
 * Navigates to a candidate's detail page.
 *
 * The previous version called history.push, which is not in scope under React
 * Router v6 - useNavigate was imported and assigned but never used, so every
 * candidate click threw and the detail page was never actually reachable.
 *
 * It also routed on the candidate's name and smuggled the ID through
 * navigation state. Only the FEC candidate ID travels now: CandidateDetailPage
 * parses office and state back out of it and fetches the rest itself, so a
 * pasted, refreshed or shared link behaves exactly like a click.
 *
 * @returns {(candidateId: string) => void}
 */
const UseHandleContainerClickCandidate = () => {
  const navigate = useNavigate();

  const handleContainerClickCandidate = (candidateId) => {
    if (!candidateId) return;

    window.scrollTo(0, 0);
    navigate(`/us/candidate/${candidateId}`);
  };

  return handleContainerClickCandidate;
};

export default UseHandleContainerClickCandidate;